// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vendorDetailsPageRoot .VendorCodesTabs .ant-tabs-nav {\n  margin: 0 24px;\n}\n", "",{"version":3,"sources":["webpack://./src/css/pages/vendor/VendorDetailPage.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB","sourcesContent":[".vendorDetailsPageRoot .VendorCodesTabs .ant-tabs-nav {\n  margin: 0 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
